import { z } from 'zod';

export const userHistoryOptionsSchema = z.object({
    canEditHistory: z.boolean(),
    canReadHistory: z.boolean(),
});

export type UserHistoryOptions = z.infer<typeof userHistoryOptionsSchema>;
